import type { DriveStep } from 'driver.js';

export const attorneyDashboardSteps: DriveStep[] = [
  {
    element: '[data-tour="attorney-dashboard-hero"]',
    popover: {
      title: 'Welcome to ExpertMD',
      description:
        'Preview your client intake form and share it with clients who need expert witness services.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="attorney-dashboard-stats"]',
    popover: {
      title: 'Practice Overview',
      description: 'Revenue, active cases, outstanding invoices, and deliverable fulfillment rate.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="attorney-dashboard-encryption"]',
    popover: {
      title: 'Data Security',
      description:
        'Unlock encryption to view sensitive case details. Lock again when stepping away.',
      side: 'left',
      align: 'center',
    },
  },
  {
    element: '[data-tour="attorney-dashboard-referral"]',
    popover: {
      title: 'Referral Program',
      description:
        'Share your link with colleagues — earn 25% of platform fees for 12 months per sign-up.',
      side: 'top',
      align: 'center',
    },
  },
  {
    element: '[data-tour="attorney-dashboard-activity"]',
    popover: {
      title: 'Recent Activity',
      description:
        'Latest case updates, invoice changes, and deliverable completions in real time.',
      side: 'top',
      align: 'center',
    },
  },
];
